<template>
  <div id="container">
  </div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";
import { deviceLocate } from '@/assets/api/zhongduan'
import { deviceDetails } from '@/assets/api/api'
import location from '@/assets/mapPeople/people.png'
import mapYuan from '@/assets/mapPeople/yuan.png'


window._AMapSecurityConfig = {
          securityJsCode: 'f2269481aca2ae2acdcc9267ed73aa7c'
    }
export default {
  name: "map-view",
  props: [ 
    'deviceLocationDetails',
    'status',
    'addressSplitJoint',
    'banjingValue',
    'statusCartoon',
    'listDatazuobiao',
    'SlistData',
    'zhongduanItem',
    'zhongduanRadius',
    'GtsDataList'
  ],
  data(){
      return {
        address:'上海市上海市天山路小学',
        //marker:null
        objLocation: {},
        lnglatsItem: {},
        LnglatsMarker: [],
        infoWindow:null,
        // map:undefined
      }
  },

  mounted() {
      //DOM初始化完成进行地图初始化
      
    this.initAMap();
    console.log(this.status,'那个页面打开的'); // 1：监控平台，2：围栏设置
    window.zhongduan = this.zhongduan
    window.dingwei = this.dingwei
    window.sportsClick = this.sportsClick
    window.guijiLook = this.guijiLook
    window.userDevice = this.userDevice
      //用户下设备的功能事件
      window.UsersportsClick = this.UsersportsClick
      window.UserguijiLook = this.UserguijiLook
      window.Userzhongduan = this.Userzhongduan
      window.closeInfo = this.closeInfo
  },
  unmounted() {
    this.map?.destroy();
  },
  watch: {
    deviceLocationDetails () { 
      console.log(this.deviceLocationDetails,'地址信息8*******');
      this.initAMap();
    },
    addressSplitJoint () {
      this.initAMap();
    },
    listDatazuobiao () {
      this.initAMap();
    },
    banjingValue () {
      this.initAMap();
    },  
    zhongduanRadius (value) {
      this.zhongduanLocation()
      this.deviceCircle(this.objLocation);
      // document.getElementById('tipinput').innerText = '';
      console.log(value,777897899);
    },  
    zhongduanItem (value) {
      console.log(value,'[[[[[[[[[[[]]]]]]]]]]]');
    },
    statusCartoon (value) {
      if ( value == '开始动画' ) {
        // this.trackShow()
        console.log(789789,this.listDatazuobiao[this.listDatazuobiao.length-1],this.SlistData);
        this.marker.moveAlong(this.listDatazuobiao, {
            // 每一段的时长
          duration: 1900, //可根据实际采集时间间隔设置
          // JSAPI2.0 是否延道路自动设置角度在 moveAlong 里设置
          autoRotation: false,
        });
      } else if ( value == '暂停动画' ){
        this.marker.pauseMove();
      } else if ( value == '继续动画' ) {
        this.marker.resumeMove();
      } else if ( value == '停止动画' ) {
        this.marker.stopMove()
      }
    },
  },  
  created(){
   
  },
  methods: {
    // 地图初始化
    initAMap() {
      AMapLoader.load({
        key: "4017c4d793ff24df61d0bc3f37ba10d1", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
       // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        plugins: [
            'AMap.ToolBar',
            'AMap.Scale',
            "AMap.Geolocation", //定位控件，用来获取和展示用户主机所在的经纬度位置
            "AMap.Geocoder",
            'AMap.PlaceSearch',
            'AMap.AutoComplete'
             ],
        resizeEnable: true,
        

      }).then((AMap) =>   {
          this.map = new AMap.Map("container", {
            // 设置地图容器id
            viewMode: "2D", // 是否为3D地图模式
            zoom: 13, // 初始化地图级别
            // center: [116.397428, 39.90923], // 初始化地图中心点位置
            // center: [114.06455183659, 22.548456637984], // 初始化地图中心点位置

          });
          this.map.addControl(new AMap.ToolBar()) //在图面添加鹰眼控件，在地图右下角显示地图的缩略图
          if (this.status == 1) {
            console.log('触发',this.GtsDataList);
            console.log('触发',this.deviceLocationDetails);
            if (  JSON.stringify(this.deviceLocationDetails) != '{}') {
              this.showLocation() //新增标记并展示信息窗体
            } else {
              this.LookUserLocation() // 多点定位
            }
            // this.map.addControl(new AMap.Scale()) // 在图面添加比例尺控件，展示地图在当前层级和纬度下的比例尺
          } else if (this.status == 2) {
            console.log('围栏设置');
            this.getLocation()
          } else if (this.status == 3) {
            console.log('产看轨迹');
            this.trackShow()
            // this.startAnimation()
          } else if (this.status == 4) {
            console.log('终端设置，围栏');
            this.weiLanSetting()
            if ( JSON.stringify(this.zhongduanItem) !='{}' ) {
              console.log(this.zhongduanItem,8899999);
              let value = {
                name: this.zhongduanItem.addr,
                location: {
                  lng: this.zhongduanItem.longitude,
                  lat: this.zhongduanItem.latitude
                }
              }
              this.objLocation = value
              var marker = new AMap.Marker({
                position: new AMap.LngLat(value.location.lng,value.location.lat),
                icon: '',
              })
              this.map.add(marker);
              this.deviceCircle(value)
            }
          } 
        
        })
        .catch((e) => {
          console.log(e);

        });
      
    },
  
    //查询用户下的设备
    LookUserLocation(){
      this.LnglatsMarker = []
      const that = this
      var lnglats = this.GtsDataList 
      console.log(lnglats,'slnkkkkkkkkkk011111');
      
      var infoWindow = new AMap.InfoWindow({offset: new AMap.Pixel(16, -35)});
            //实例化信息窗体
      for (var i = 0, marker; i < lnglats.length; i++) {
          var marker = new AMap.Marker({
              position: lnglats[i].position,
              extData: lnglats[i],
              map: that.map,
          });
          // 位置点转换成设备名字
          var markerInfoObj = new AMap.Marker({
              position: lnglats[i].position,
              extData: lnglats[i],
              map: that.map,
              content: `<div class="markerInfo">${lnglats[i].deviceName}</div>`
                        
          });
          // this.LnglatsMarker = marker
          marker.content = '地址：' + lnglats[i].addr;
          console.log(marker.content,8888);
          // marker.emit('click', {target: marker});
          this.LnglatsMarker.push(marker)
          marker.on('click', (e) => {
            infoWindow.setContent(e.target.content);
            let item = e.target.getExtData(); // 获取item , 这个getExtData()是AMap.Marker的扩展方法
            window.userDevice(item)
          });
      }

      //获取imei
     
      if(this.$route.query.imei){
        deviceDetails({imei:this.$route.query.imei,userId:JSON.parse(localStorage.getItem('user')).id}).then(res => {
          this.lnglatsItem = res.data.data;
          this.LnglatsMarker.forEach((item,index)=> {
            console.log("🚀 ~ this.LnglatsMarker.forEach ~ item:", item)
            if(item._originOpts.extData.deviceId == res.data.data.deviceId) {
              // console.log(item,index,'选择');
              this.manyLocation(this.LnglatsMarker[index])
            }
          })
        })
      }
      that.map.setFitView();
    },
 
    manyLocation (marker) {
     this.infoWindow = new AMap.InfoWindow({
              // content: info.join(""),
            isCustom: true, //是否自定义信息窗体
            content:`<div style="background-color: white; padding: 10px 15px;width:300px; border-radius: 5px; font-size:15px;border: 1px solid #cccccc;"> 
                    <div style="font-weight: 700;">个人信息<botton onclick="closeInfo();" style="margin-left:68%;font-size:16px">×</botton></div> 
                    <div style="margin-top: 8px;" ><span style="font-weight: 700;">名称:${this.lnglatsItem.deviceName}</span><span style="margin-left: 15px;"><span style="font-weight: 700;">状态:</span>${this.lnglatsItem.status==1?'在线':'离线'}</span><span style="margin-left: 15px;"><span style="font-weight: 700;">电量:</span>${this.lnglatsItem.bat}%</span></div>
                    <div style="margin-top: 8px;"><span style="font-weight: 700;">时间:</span>${this.lnglatsItem.lastUpdateTime}</div>
                    <div style="margin-top: 8px;"><span style="font-weight: 700;">IMEI:</span>${this.lnglatsItem.imei}</div>
                    <div style="margin-top: 8px;"><span style="font-weight: 700;">本机号码:</span>${this.lnglatsItem.phoneNumber?this.lnglatsItem.phoneNumber :'暂无数据'}</div>
                    <div style="margin-top: 8px;"><span style="font-weight: 700;">位置:</span>${this.lnglatsItem.address}</div>
                    <div style="margin-top: 8px;"><span style="font-weight: 700;">sos号码1:</span>${this.lnglatsItem.sosPhone1 ?this.lnglatsItem.sosPhone1 :'暂无数据'}</div>
                    <div style="margin-top: 8px;"><span style="font-weight: 700;">sos号码2:</span>${this.lnglatsItem.sosPhone2 ? this.lnglatsItem.sosPhone2 :'暂无数据'}</div>
                    <button  type="text" style="color:#2C9DF7;margin-top: 8px; font-weight: 700; margin-right: 5px;"  onclick="dingwei()" >立即定位</button>
                    <button type="text" style="margin-right: 3px; color:#2C9DF7 ;margin-top: 8px;font-weight: 700;" onclick="Userzhongduan()" >终端设置</button>
                    <button type="text" style="margin-right: 3px; color:#2C9DF7 ;margin-top: 8px;font-weight: 700;" onclick="UsersportsClick()" >运动计步</button>
                    <button type="text" style="margin-right: 3px; color:#2C9DF7 ;margin-top: 8px;font-weight: 700;" onclick="UserguijiLook()" >轨迹查询</button>
                    
                </div>
              `,
            // 开启后点击不了地图上的任何位置
            // closeWhenClickMap: true,
            zIndex: 999,
            offset: new AMap.Pixel(16, -35), 
        });
      this.infoWindow.open(this.map, marker.getPosition());
    },
      //用户设备信息 点击之后位置请求
    userDevice(lnglats,marker){
        console.log(lnglats,99999999);
        const params = {
          deviceId:lnglats.deviceId,
        }
        deviceDetails(params).then((res) => {
          console.log(res,1);
          this.lnglatsItem = res.data.data
          // for ()
          console.log(this.LnglatsMarker);
          this.LnglatsMarker.forEach((item,index)=> {
            if(item._originOpts.extData.id == lnglats.id) {
              // console.log(item,index,'选择');
              this.manyLocation(this.LnglatsMarker[index])
            }
          })
        }).catch((err)=> {
          console.log(err,2);
        })
    },

    // 终端设置围栏
    weiLanSetting(){
      let that = this;
        var autoOptions = {
                input: document.getElementById('tipinput')
            };

        var auto = new AMap.AutoComplete(autoOptions);
        var placeSearch = new AMap.PlaceSearch({
            map: that.map,
            autoFitView: false,
            zoomToAccuracy: true
        });  //构造地点查询类

        AMap.Event.addListener(auto, 'select', seach);
        function seach(e) {
            placeSearch.setCity(e.poi.adcode);
            placeSearch.search(e.poi.name, function(status, result) {
              var pois = result.poiList.pois;
              console.log(pois,777777777);
              for (var i = 0; i < pois.length; i++) {
                var poi = pois[i];
                var marker = [];
                that.map.clearMap()
                marker[i] = new AMap.Marker({
                  position: poi.location,
                  title: poi.name,
                  map:that.map,
                });
                console.log(marker[i],'slne');
                that.map.add(marker[i]); // 将创建的点标记添加到已有的地图实例
                that.deviceCircle(e.poi)
              }
            that.map.setFitView();
            that.objLocation = e.poi

            });
            console.log("eeeeeeeeeeeeeeeeeeeeeeeee", e.poi);
          
      }
    },
    //终端围栏圆
    deviceCircle(value){
      console.log(this.zhongduanRadius,7777777777777);
        this.$emit('zhongDuanPosition',value)
        //设置圆形位置
          const center = new AMap.LngLat(value.location.lng, value.location.lat)
          //设置圆的半径大小
          // const radius = 1000
          // 创建圆形 Circle实例
           let  circle = new AMap.Circle({
              center:center, //圆心
              radius: this.zhongduanRadius == '' ? 300:this.zhongduanRadius  , //半径
              borderWeight: 3,
              strokeColor: "#FF33FF", 
              strokeOpacity: 1,
              strokeWeight: 6,
              strokeOpacity: 0.2,
              fillOpacity: 0.4,
              // strokeStyle: 'dashed',
              strokeDasharray: [10, 10], 
              // 线样式还支持 'dashed'
              fillColor: '#1791fc',
              zIndex: 50,
            })
        //圆形 Circle 对象添加到 Map
        this.map.add(circle);
        // 缩放地图到合适的视野级别
        this.map.setFitView([ circle ])
    },

  // 位置点 
  zhongduanLocation(){
    let marker = new AMap.Marker({
        position: new AMap.LngLat(this.objLocation.location.lng,this.objLocation.location.lat) //参数为经纬度
    })
    this.map.clearMap()// 清除所有覆盖物（点标志）
    this.map.add(marker)// 添加点标志
  },

    //轨迹查询
    trackShow(){
      AMap.plugin("AMap.MoveAnimation", function () {});//轨迹回放
      // var marker,startMarker,endMarker,lineArr =  [[121.395094,31.212809],[121.395385,31.21398]]
      var marker,startMarker,endMarker,lineArr =  this.listDatazuobiao
      var markerIcon = new AMap.Icon({
              // 图标尺寸
              size: new AMap.Size(30, 50),
              // 图标的取图地址
              image: location,
              // 图标所用图片大小
              imageSize: new AMap.Size(30,30),
              // 图标取图偏移量
              // imageOffset: new AMap.Pixel(-5, -1)
          });
          // 运动点
          this.marker = new AMap.Marker({
            map: this.map,
            position:this.listDatazuobiao[0],
            // icon: "https://a.amap.com/jsapi_demos/static/demo-center-v2/car.png",
            icon: markerIcon,
            offset: new AMap.Pixel(-16, -30),
            zIndex:3,
            
          });
        // 创建起点 Icon
        var startIcon = new AMap.Icon({
              // 图标尺寸
              size: new AMap.Size(25, 34),
              // 图标的取图地址
              image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
              // 图标所用图片大小
              imageSize: new AMap.Size(135, 40),
              // 图标取图偏移量
              imageOffset: new AMap.Pixel(-9, -3)
          });

          // // 将 起点icon 传入 marker
           startMarker = new AMap.Marker({
            position:this.listDatazuobiao[0],
              icon: startIcon,
              offset: new AMap.Pixel(-13, -30),
              zIndex:2,

          });

          // 创建结束icon
          var endIcon = new AMap.Icon({
              size: new AMap.Size(25, 34),
              image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
              imageSize: new AMap.Size(135, 40),
              imageOffset: new AMap.Pixel(-95, -3)
          });

          // 将结束icon 传入 marker
           endMarker = new AMap.Marker({
            position: this.listDatazuobiao[this.listDatazuobiao.length-1],
              icon: endIcon,
              offset: new AMap.Pixel(-13, -30),
              zIndex:2,
          });

          this.map.add([ startMarker,endMarker]);
                  
            // 绘制历史轨迹
          var polyline = new AMap.Polyline({
              map: this.map,
              path: lineArr,
              showDir:true,
              strokeColor: "#28F",  //线颜色
              // strokeColor: "red",  //线颜色
              // strokeOpacity: 1,     //线透明度
              strokeWeight: 7,      //线宽
          // strokeStyle: "solid"  //线样式
        });  
        // 驾驶途径过的轨迹
        var passedPolyline = new AMap.Polyline({
          map: this.map,
          strokeColor: "#AF5",  //线颜色
          // strokeColor: "#28F",  //线颜色
          strokeWeight: 7,      //线宽
        });

        // if ( this.statusCartoon == '开始动画' ) {
        //   //     //调用方法开启动画
         
        // }
        // if ( this.statusCartoon == '暂停动画' ) {
        //   //     //调用方法开启动画
        //   marker.pauseMove();
        //   console.log('暂停123123');
        // }
        this.marker.on("moving", e => {
          
          passedPolyline.setPath(e.passedPath);
        });
         this.map.setFitView();

        //测试
        var style = {
              url: mapYuan, //图标地址
              size: new AMap.Size(30,30), //图标大小
              anchor: new AMap.Pixel(15, 15), //图标显示位置偏移量，基准点为图标左上角
            };
       
          this.SlistData.forEach((item,index)=> {
            item.lnglat= [ item.lng1,item.lat1]
            item.name= item.addr
          })
          console.log(this.SlistData);
        var massMarks = new AMap.MassMarks(this.SlistData,{
              zIndex: 18, //海量点图层叠加的顺序
              zooms: [3, 19], //在指定地图缩放级别范围内展示海量点图层
              style: style, //设置样式对象
            });
            let htis = this
            massMarks.setMap(this.map);
            massMarks.on('click', function (e) {
              console.log(e.data.name,'sln111111');
              htis.$emit('statusCartoonClick', e.data.name)
              // marker.setPosition(e.data.name);
              // marker.setLabel({content: e.data.name})
            });
  
          

                

    },
  //  地址逆解析
    getLocation(address) {
      //地址逆解析插件
      AMap.plugin("AMap.Geocoder", () => {
        let  geoCoder = new AMap.Geocoder({
          city: "全国", //城市设为北京，默认：“全国”
          // radius: 1000, //范围，默认：500,
        });
        let marker = new AMap.Marker({offset: new AMap.Pixel(0, 0)})
        let zoom = Math.floor(Math.random() * 6) + 14; //zoom范围[11,18]
          // geoCoder.getLocation('上海市浦东新区周浦医院', (status, result) => {
          geoCoder.getLocation(this.addressSplitJoint, (status, result) => {
            console.log('result',result,status)
            if (status === 'complete' && result.geocodes.length) {
              const lnglat = result.geocodes[0].location
                // this.map.clearMap()// 清除所有覆盖物（点标志）
                marker.setPosition(lnglat);
                this.map.add(marker);
                this.map.setFitView(marker);
                this.map.setZoom(zoom); //设置地图层级
                this.showCircle(lnglat.lng,lnglat.lat)
                this.$emit('jingweidu',lnglat.lng,lnglat.lat)
            } else {
              console.error('根据地址查询位置失败')
            }
          })
      })
    },
   //设置圆 
    showCircle(Slng,Slat){
      console.log(this.banjingValue == ''? 300:this.banjingValue);
        //设置圆形位置
          // const center = new AMap.LngLat(116.433322, 39.900255)
          //设置圆的半径大小
          // const radius = 1000
          // 创建圆形 Circle实例
           let  circle = new AMap.Circle({
              center: new AMap.LngLat(Slng,Slat,), //圆心
              radius: this.banjingValue == ''? 300:this.banjingValue , //半径
              borderWeight: 3,
              strokeColor: "#FF33FF", 
              strokeOpacity: 1,
              strokeWeight: 6,
              strokeOpacity: 0.2,
              fillOpacity: 0.4,
              // strokeStyle: 'dashed',
              strokeDasharray: [10, 10], 
              // 线样式还支持 'dashed'
              fillColor: '#1791fc',
              zIndex: 50,
            })
        //圆形 Circle 对象添加到 Map
        this.map.add(circle);
        // 缩放地图到合适的视野级别
        this.map.setFitView([ circle ])
      },
    // 位置点 
    showLocation(){
      var position = new AMap.LngLat(this.deviceLocationDetails.lng1,this.deviceLocationDetails.lat1) //参数为经纬度
          let marker = new AMap.Marker({
                  position:position
          })

          this.map.clearMap()// 清除所有覆盖物（点标志）
          this.map.add(marker)// 添加点标志
          this.showInfoWindow(marker);//自定义信息窗体
          this.map.setCenter(position);//位置点显示在地图中间
          // marker.showInfoWindow()
          marker.on('click', (e) => {
          this.showInfoWindow(marker);//自定义信息窗体
            // this.showInfoWindow()
            // infoWindow.setContent(e.target.content);
            // let item = e.target.getExtData(); // 获取item , 这个getExtData()是AMap.Marker的扩展方法
            // window.userDevice(item)
          });
          },
    closeInfo() {
        this.infoWindow.close();
      },
    //自定义信息窗体
    showInfoWindow(marker){
   
          this.infoWindow = new AMap.InfoWindow({
              // content: info.join(""),
              isCustom: true, //是否自定义信息窗体
              content:`<div style="background-color: white; padding: 10px 15px;width:300px; border-radius: 5px; font-size:15px;border: 1px solid #cccccc;"> 
                  <div style="font-weight: 700;">个人信息 <botton onclick="closeInfo();" style="margin-left:68%;font-size:16px">×</botton></div> 
                  <div style="margin-top: 8px;" ><span style="font-weight: 700;">名称::${this.deviceLocationDetails.deviceName}</span><span style="margin-left: 15px;"><span style="font-weight: 700;">状态:</span>${this.deviceLocationDetails.status==1?'在线':'离线'}</span><span style="margin-left: 15px;"><span style="font-weight: 700;">电量:</span>${this.deviceLocationDetails.bat}%</span></div>
                  <div style="margin-top: 8px;"><span style="font-weight: 700;">时间:</span>${this.deviceLocationDetails.lastUpdateTime}</div>
                  <div style="margin-top: 8px;"><span style="font-weight: 700;">IMEI:</span>${this.deviceLocationDetails.imei}</div>
                  <div style="margin-top: 8px;"><span style="font-weight: 700;">本机号码:</span>${this.deviceLocationDetails.phoneNumber? this.deviceLocationDetails.phoneNumber :'暂无数据'}</div>
                  <div style="margin-top: 8px;"><span style="font-weight: 700;">位置:</span>${this.deviceLocationDetails.address}</div>
                  <div style="margin-top: 8px;"><span style="font-weight: 700;">sos号码1:</span>${this.deviceLocationDetails.sosPhone1 ? this.deviceLocationDetails.sosPhone1 :'暂无数据'}</div>
                  <div style="margin-top: 8px;"><span style="font-weight: 700;">sos号码2:</span>${this.deviceLocationDetails.sosPhone2 ? this.deviceLocationDetails.sosPhone2 :'暂无数据'}</div>
                  <button  type="text" style="color:#2C9DF7;margin-top: 8px; font-weight: 700; margin-right: 5px;"  onclick="dingwei()" >立即定位</button>
                  <button type="text" style="margin-right: 3px; color:#2C9DF7 ;margin-top: 8px;font-weight: 700;" onclick="zhongduan()" >终端设置</button>
                  <button type="text" style="margin-right: 3px; color:#2C9DF7 ;margin-top: 8px;font-weight: 700;" onclick="sportsClick()" >运动计步</button>
                  <button type="text" style="margin-right: 3px; color:#2C9DF7 ;margin-top: 8px;font-weight: 700;" onclick="guijiLook()" >轨迹查询</button>
                  
              </div>`,
              // 开启后点击不了地图上的任何位置
              // closeWhenClickMap: true,
              zIndex: 999,
              offset: new AMap.Pixel(16, -35),
          });
        //  this.infoWindow.open(this.map, marker.getPosition());
            this.infoWindow.open(this.map, marker.getPosition());

          },
      //轨迹查询
      guijiLook(){
        const routeUrl = this.$router.resolve({
              path: '/view-tracks',
              query: {deviceId:this.deviceLocationDetails.deviceId,iemi:this.deviceLocationDetails.imei,name:this.deviceLocationDetails.deviceName},
              // params:this.lnglatsItem
           })
       window.open(routeUrl.href, '_blank')
        console.log(this.deviceLocationDetails,'sln11111');
      },
      //终端设置
      zhongduan () {
      //  this.$router.push({
      //    name: 'terminalStiing', state: this.lnglatsItem 
      //  })
      // 此方法跳转可以打开新页面
          const routeUrl = this.$router.resolve({
              path: '/zhongduan-setting',
              query: {deviceId:this.deviceLocationDetails.deviceId,iemi:this.deviceLocationDetails.imei,name:this.deviceLocationDetails.deviceName},
              // params:this.lnglatsItem
           })
       window.open(routeUrl.href, '_blank')

       console.log(this.deviceLocationDetails,this.lnglatsItem,'终端设置');
     },
      //运动计步
      sportsClick () {
        // 在当前页面打开
        const routeUrl = this.$router.resolve({
              path: '/sports-step',
              query: {deviceId:this.deviceLocationDetails.deviceId,iemi:this.deviceLocationDetails.imei,name:this.deviceLocationDetails.deviceName},
              // params:this.lnglatsItem
           })
       window.open(routeUrl.href, '_blank')
      },
      //立即定位
      dingwei(){
        // console.log('我是立即定位',this.deviceLocationDetails.imei);
        const params ={
          imei:this.deviceLocationDetails.imei ||this.lnglatsItem.imei
        };
        deviceLocate(params).then((res)=> {
          this.$alert(res.data.msg, '操作提示', {
          confirmButtonText: '确定',
        });
        }).catch((err) => {
          // console.log(err);
          // this.$message({
          //           type: 'error',
          //           message: err.response.data.msg
          //       });
          this.$alert(err.response.data.msg, '操作提示', {
          confirmButtonText: '确定',
        });

        })

      },
     //轨迹查询
    UserguijiLook(){
      //  this.$router.push({
      //    name: 'ViewTracks', state: this.lnglatsItem 
      //  })
      const routeUrl = this.$router.resolve({
              path: '/view-tracks',
              query: {deviceId:this.lnglatsItem.deviceId,iemi:this.lnglatsItem.imei,name:this.lnglatsItem.deviceName},
              // params:this.lnglatsItem
           })
       window.open(routeUrl.href, '_blank')
       console.log(this.deviceLocationDetails,this.lnglatsItem,'轨迹查询');
     },
     //终端设置
     Userzhongduan () {
      //  this.$router.push({
      //    name: 'terminalStiing', state: this.lnglatsItem 
      //  })
      // 此方法跳转可以打开新页面
          const routeUrl = this.$router.resolve({
              path: '/zhongduan-setting',
              query: {deviceId:this.lnglatsItem.deviceId,iemi:this.lnglatsItem.imei,name:this.lnglatsItem.deviceName},
              // params:this.lnglatsItem
           })
       window.open(routeUrl.href, '_blank')

       console.log(this.deviceLocationDetails,this.lnglatsItem,'终端设置');
     },
     //运动计步
     UsersportsClick () {
       // 在当前页面打开
      //  this.$router.push({
      //    name: 'SportsStep', state: this.lnglatsItem 
      //  })
      const routeUrl = this.$router.resolve({
              path: '/sports-step',
              query: {deviceId:this.lnglatsItem.deviceId,iemi:this.lnglatsItem.imei,name:this.lnglatsItem.deviceName},
              // params:this.lnglatsItem
           })
       window.open(routeUrl.href, '_blank')
       console.log(this.deviceLocationDetails,  );

     },
    
  },
};
</script>
<style lang='scss' scoped>
  #container {
    width: 100%;
    height: 100%;
  }
  :deep() {
    .markerInfo{
        height: 20px;
        width: 65px;
        background-color: #fff;
        border:1px #000 solid;
        border-radius: 15px;
        text-align: center;
        line-height: 20px;
        font-size: 14px;
        }
}
  
</style>
